import React from "react";
import styles from "./ItemMessage.module.scss";

interface ItemMessageProps {
  itemMessage?: string;
  buyPrice: number;
  displayPrice: number;
  className?: string;
  currencySymbol?: string;
}
export function ItemMessage({ itemMessage, currencySymbol = '₹' }: ItemMessageProps) {
  if (itemMessage) {
    const [type, value] = itemMessage.split(';');
    if (type === 'price_up') {
      return (
        <div className={styles["price-up"] + " is-flex g-5 is-align-items-start"}>
        <span>Price</span> <span className={styles["price-arrow"]}><img src={`${process.env.PUBLIC_URL}/images/icons/price-up.svg`} alt=""/></span>
        <span>by ₹{value}</span>
    </div>
      );
    } else if (type === 'price_down') {
      return (
        <div className={styles["price-down"] + " is-flex g-5 is-align-items-start"}>
            <span>Price</span> <span className={styles["price-arrow"]}><img src={`${process.env.PUBLIC_URL}/images/icons/price-down.svg`} alt=""/></span>
            <span>by ₹{value}</span>
        </div>
      );
    }
  }

  return null;
} 